import { useEffect, useState } from "react";
import { agingReport, balanceSheet, cashFlow, equityChanges, incomeStatement, segmentReport } from "../../api/accounting";

// Loads every official statement for the chosen date range.
export const useAcctReports = (range) => {
  const [data, setData] = useState({ pl: null, bs: null, cf: null, aging: null, segments: null, equity: null });

  useEffect(() => {
    let alive = true;
    (async () => {
      const [pl, bs, cf, aging, segments, equity] = await Promise.all([
        incomeStatement(range),
        balanceSheet({ date_to: range.date_to }),
        cashFlow(range),
        agingReport({ kind: "receivable" }),
        segmentReport(range),
        equityChanges(range),
      ]);
      if (alive) setData({ pl, bs, cf, aging, segments, equity });
    })();
    return () => {
      alive = false;
    };
  }, [range]);

  return data;
};
